import dc from 'dc';

function directive(getSize, $window) {
    return {
        link: function ($scope, element, attrs, dcCrtl) {
            var uid = false;// because there is one instances of this directive per view, we can assign a uid directly to it
            var hHeight, lOffset;
            var size = getSize(element, 'rowchart');
            var width = size.width;
            var dimension, group, uid, key,searchCategories, div = "#rowchart", outFilter, rowDomain; // set our default vairables
            $scope.page.w = angular.element($window);
            var uid;
            let rowchart;
            var dictionary = {
                'Guarded': '1' ,
                'Elevated': '2',
                'High': '3',
                'Severe': '4'
            };
            let oldHeight = 0;
            $scope.$on('init', function (event, chart) {
                if (chart.id !== attrs.uid) { return }
                if (typeof $scope.main.dataObjects[chart.key] === 'undefined') {
                    // if it's not in our dc object, ignore
                    return
                }
                $scope.main.dataObjects[chart.key].launched = true;
                uid = chart.id;
                key = chart.key;

                dimension = $scope.main.dataObjects[key].dimension;
                group = $scope.main.dataObjects[key].group;
                searchCategories = $scope.main.dataObjects[key].settings.searchCategories;

                rowchart = dc.rowChart(div);

                var filter = true;
                var numberFormat = d3.format(".2f");

                var count = group.top(Infinity).length; // CHANGE THIS to count return rows

                if (count < 7) {
                    lOffset = 14;
                    hHeight = ((count+1)*33);
                } else {
                    lOffset = 12;
                    hHeight = ((count+1)*29);
                }
                oldHeight = hHeight;

                // filter rules
                rowchart.on("filtered", function (chart, value) {
                    var column, title, cnt = 0;
                    if ($scope.main.dataObjects[key].settings.settings.type === 'summary') {
                        for (let s in searchCategories) {
                            column = s;
                            title = searchCategories[s];
                            $scope.main.filterItem(column, dictionary[value], "include", title);
                            break;
                        }
                    } else {
                        var val = []
                        val.push(value.slice(0, value.length-1))
                        val.push(value.slice(value.length-1, value.length))
                        for (let s in searchCategories) {
                            column = s;
                            title = searchCategories[s];
                            $scope.main.filterItem(column, val[cnt], "include", title);
                            cnt++;
                            if (cnt > 1) {
                                break;
                            }
                        }
                    }
                });

                // CALCULATING DOMAIN
                if ($scope.main.dataObjects[key].settings.settings.type === 'summary') {
                    var tops = group.order(function (p) {
                        if (typeof p !== "undefined") {
                            return p;
                        }
                    }).top(1);
                    if (tops.length === 0) {
                        rowDomain = 0;
                    } else {
                        rowDomain = tops[0].value;
                    }
                    var orderDictionary = {
                        'Guarded': 1,
                        'Elevated': 2,
                        'High': 3,
                        'Severe': 4
                    };
                    // set value accessor
                    rowchart
                        .valueAccessor(function (d) {
                            if (d.key === "") {
                                return
                            }
                            if (d.value === 0) {
                                return 0.1;
                            } else {
                                return d.value;
                            }
                        })
                        .ordering(function (d) {
                            return -(orderDictionary[d.key])
                        })
                        .colors(d3.scale
                            .ordinal()
                            .domain(['Guarded','Elevated','High','Severe'])
                            .range(["#377FC7","#F5D800","#F88B12","#FF3131"])
                        ) //["#377FC7","#FF3131","#F88B12", "#F5D800"]))
                        .colorAccessor(function (d) {
                            return d.key;
                        })
                        .label(function (d) {
                            return d.key + " (" + d.value + ")"
                        })
                } else {
                    var tops =  group.order(function (p) {
                        if ((typeof p !== "undefined") && (p.severity > 0)) {
                            return p.count;
                        }
                    }).top(1);
                    if (count > 0) {
                        rowDomain = tops[0].value.count+1.1;
                    } else {
                        rowDomain = 50;
                    }
                    rowchart
                        .valueAccessor(function (d) {
                            if (d.value.severity > 0) {
                                if (d.key === "") {return}
                                if (d.value.count === 0) {
                                    return 0.1;
                                } else {
                                    return d.value.count;
                                }
                            } else {
                                return null
                            }
                        })
                        .ordering(function (d) {
                            return -d.value.severity;
                        })
                        .colors(d3.scale
                            .ordinal()
                            .domain([1,2,3,4])
                            .range(["#377FC7","#F5D800","#F88B12","#FF3131"])
                        ) // ["#377FC7","#FF3131","#F88B12", "#F5D800"]))
                        .colorAccessor(function (d) {
                            if (d.value.severity > 0) {
                                return d.value.severity;
                            }else {
                                return null
                            }
                        })
                        .renderLabel(true)
                        .margins({
                            top: 5,
                            left: 0,
                            right: 0,
                            bottom: 20
                        })
                        .label(function (d) {
                            if (d.value.severity > 0) {
                                if (d.key === "") {
                                    return ""
                                }
                                return d.key.substring(0, d.key.length - 1)+' ('+d.value.count+')';
                            } else {
                                return null
                            }
                        })
                        .labelOffsetY(lOffset);
                }
                // AXIS FORMATTING
                var numberFormat = d3.format(",f");
                function logFormat(d) {
                    var x = Math.log(d) / Math.log(10) + 1e-6;
                    return Math.abs(x - Math.floor(x)) < 0.3 ? numberFormat(d) : "";
                }
                rowchart
                    .width(width)
                    .height(hHeight)
                    .group(group)
                    .dimension(dimension)
                    .elasticX(false)
                    .x(d3.scale.log().clamp(true).domain([0.9, rowDomain]).range([0,width])) // 500 ->width
                    .xAxis()
                    .scale(rowchart.x())
                    .tickFormat(logFormat);

                d3.select(div+' svg')
                    .attr('width', width)
                    .attr('height', hHeight);
                $(element).height(hHeight);
                rowchart.render();
            });
            // set update functions
            $scope.$on('updatedData', function (event, id) {
                if (id !== uid) {
                    // only run when it sees its id has filtered
                    return
                }
                if ($scope.main.dataObjects[key].settings.settings.type === 'summary') {
                    var tops = group.order(function (p) {
                        if (typeof p !== "undefined") {
                            return p;
                        } else {
                            return 0
                        }
                    }).top(1);
                    if (tops.length === 0) {
                        rowDomain = 0;
                    } else {
                        rowDomain = tops[0].value;
                    }
                } else {
                    var count = group.top(Infinity).length; // CHANGE THIS to count return rows
                    var tops =  group.order(function (p) {
                        if (typeof p !== "undefined") {
                            return p.count;
                        } else {
                            return 0
                        }
                    }).top(1);
                    if (count > 0) {
                        rowDomain = tops[0].value.count+1.1;
                    } else {
                        rowDomain = 50;
                    }
                }
                if (count < 7) {
                    lOffset = 14;
                    hHeight = ((count+1)*33);
                } else {
                    lOffset = 12;
                    hHeight = ((count+1)*29);
                }
                rowchart.height(hHeight)
                    .x(d3.scale.log().clamp(true).domain([0.9, rowDomain]).range([0,width]))
                    .labelOffsetY(lOffset);;
                d3.select(element[0])
                    .select('svg')
                    .attr('width', width)
                    .attr('height', hHeight)
                $(element).height(hHeight);
                if (oldHeight !== hHeight) {
                    rowchart.render();
                    oldHeight = hHeight;
                } else {
                    rowchart.redraw();
                }
            });

            let resizeTimeout;
            $scope.page.w.bind('resize', function () {
                if ( !resizeTimeout ) {
                    if (typeof rowchart !== "undefined") {
                        resizeTimeout = setTimeout(function () {
                            resizeTimeout = null;
                            size = getSize(element, 'rowchart');
                            width = size.width;
                            rowchart
                                .width(width)
                                .x(d3.scale.log().clamp(true).domain([0.9, rowDomain]).range([0,width]));
                                d3.select(element[0]).select('svg').attr('width', width)
                            rowchart.redraw();
                        }, 250);
                    }
                }
            });

            $scope.$on('$destroy', function () {
                element.remove();
                rowchart = undefined
                $scope.page.w = null;
            });
        }
    }
}

directive.$inject = ['getSize', '$window'];
module.exports = directive;


/** WEBPACK FOOTER **
 ** ./src/pages/directives/rowchart/makerowchart.js
 **/